import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const config = {
    apiKey: "AIzaSyAKwJyWJePXzzOXckNXsDmKgLELEEndZXw",
    authDomain: "portfolio-f8cb8.firebaseapp.com",
    databaseURL: "https://portfolio-f8cb8-default-rtdb.firebaseio.com",
    projectId: "portfolio-f8cb8",
    storageBucket: "portfolio-f8cb8.appspot.com",
    messagingSenderId: "1004253190457",
    appId: "1:1004253190457:web:c638237be1d32b3640b0e8"
};

firebase.initializeApp(config);

const db = firebase.firestore()
const auth = firebase.auth()

export {db, auth, firebase}